import React, { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReCAPTCHA from "react-google-recaptcha"
import jwt_decode from 'jwt-decode';
import axios from 'axios';
import { getPermissions, set_user_info } from "../../Redux/Actions/login_actions"
function LoginComp() {
  const captchaRef = useRef(null)
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem('key'));
  const userId = localStorage.getItem('userId');

  let navigate = useNavigate()
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [passtype, setPasstype] = useState('password');
  const [succerr, setSuccerr] = useState('');
  const [err, setErr] = useState('');
  const [error, setError] = useState('');
  const [login, setLogin] = useState(true)
  const [loginforgot, setLoginforgot] = useState(false)
  const [forgotpassword, setForgotpassword] = useState(false)
  const [emailresetpassword, setEmailresetpassword] = useState('')
  const [otpscreen, setOtpscreen] = useState(false);
  const [resetpassmsg, setResetpassmsg] = useState('');
  const [otp, setOtp] = useState()
  const [newpassword, setNewpassword] = useState('');
  const [confirmpassword, setConfirmpassword] = useState('');
  const handleShowPassword = () => {
    if(passtype=='text'){
      setPasstype('password');
    }else{
      setPasstype('text')
    }
    
  }
  // const handlePasswordChange = () => {
  //   setPasstype('password')
  // }

  const dispatch = useDispatch()


  const fetchData = async () => {
    const response = await fetch(SERVER_URL + `api/login`,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          password: pass
        }),
      })
      .then(res => res.json())
      .then(data => { 
        if (data.status == true) {
          setSuccerr(data.msg)
          setErr('green')
          const tokenDecoded = jwt_decode(data.token)
          //  console.log(tokenDecoded)
          //  alert('ok o');
          const dept_id = tokenDecoded.dept_id;
          const item = {
            value: data.token,
            expiry: tokenDecoded.exp,
            userId: tokenDecoded.userId
          }
          localStorage.setItem('key', JSON.stringify(item))
          localStorage.setItem('userId', tokenDecoded.userId)
          localStorage.setItem('systemRole', tokenDecoded.systemRole)

          dispatch(getPermissions(tokenDecoded.userId));
          dispatch(set_user_info(tokenDecoded.userId));

          setTimeout(function () {
            navigate("/dashboard")
          }, 1000);
        }
        else {
          setSuccerr(data.msg)
          setErr('red')
        }
      })
  }
  const handleLogin = async (e) => {
    e.preventDefault()
    fetchData()
  }


  const handleResetPassword = () => {
    setLogin(false)
    setLoginforgot(true)
    setOtpscreen(false)
    setForgotpassword(false)
  }
  const handleResetPasswordCancel = () => {
    setLogin(true)
    setLoginforgot(false)
    setOtpscreen(false)
    setForgotpassword(false)
  }
  const handleResetPasswordOTP = () => {
    setLogin(false)
    setLoginforgot(false)
    setOtpscreen(true)
    setForgotpassword(false)
  }
  const handleconfirmpassword = () => {
    setLogin(false)
    setLoginforgot(false)
    setOtpscreen(false)
    setForgotpassword(true)
  }
  const handleuserEmail = () => {
    setResetpassmsg('')
    setErr('')
    let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regEmail.test(emailresetpassword)) {
      setResetpassmsg(' Is not valid')
      setErr('red')
    } else {
      sendOtp()
    }
  }
  function sendOtp() {
    const response = fetch(SERVER_URL + `api/login/forgot-password`,
      {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',

        },
        body: JSON.stringify({
          email: emailresetpassword
        }),
      }).then(res => res.json())
      .then(data => {
       // console.log(data)
        if (data.status == false) {
          setResetpassmsg(' is not exist')
          setErr('red')
          return false
        } if (data.status == true) {
          setResetpassmsg('  ')
          setErr('green')
          handleResetPasswordOTP()
        }

      })
  }
  const handleuserOTP = () => {
    const response = fetch(SERVER_URL + `api/login/otp-verify`,
      {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',

        },
        body: JSON.stringify({
          email: emailresetpassword,
          code: otp
        }),
      }).then(res => res.json())
      .then(data => {
        //console.log(data)
        if (data.status == true) {
          setResetpassmsg(' ')
          handleconfirmpassword()
        } else {
          setResetpassmsg(' OTP is expired or not valid')
          setErr('red')
        }
      })
  }
  const handleChangePassword = async () => {
    if (newpassword !== confirmpassword) {
      setResetpassmsg(' doesn`t match')
      setErr('red')
    } else {
      const response = await fetch(SERVER_URL + `api/login/change-new-password`, {
        method: "PUT",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: emailresetpassword,
          password: newpassword
        }),
      });
      if (response.ok == true) {
        setResetpassmsg(' password has been changed successfully')
        setErr('green')
        setTimeout(function () {
          handleResetPasswordCancel()
        }, 1000);
      } else {
        setResetpassmsg(' Something wend wrong!')
        setErr('red')
      }

    }
  }
  const handleResendOtp = () => {
    sendOtp()
  }
  return (
    <div className="login_container">
      {/* {
        succerr && <p className='textError'>Error!! {succerr}</p>
      } */}
      <div className="left_panel_login">
        <div className="loginbg_blk">
          <img src="assets/images/login.svg" alt="" />
        </div>
      </div>
      <div className="right_panel_login">
        <div className="login_wrapper">
          <div className="login_blk">
            <div className='whitebox_wrp' style={{ display: login ? 'block' : 'none' }}>
              <form>
                <div className="login_head">
                  <div className="logo_blk"><img src="assets/images/logo.png" /></div>
                </div>
                <div className="formblk mb20">
                  <label className="form-label">Email or Employee Code</label>
                  <div className="form-input">
                    <input onChange={(e) => { setEmail(e.target.value) }} value={email} type="text" className="form-control" placeholder="Enter your mail or employee code" />
                  </div>
                </div>
                <div className="formblk mb10">
                  <label className="form-label">Password</label>
                  <div className="form-input">
                    <input onChange={(e) => { setPass(e.target.value) }} value={pass} type={passtype ? passtype : 'password'} className="form-control" placeholder="Enter your  Password" />
                    <span className="icon_wrp">
                      <i  className={`${passtype=="text"?'icon icon-eye-crossed':'icon icon-eye'}`} onClick={handleShowPassword} ></i>
                   
                      </span>
                  </div>
                </div>

                <div className="formblk mb10">
                  <span style={{ color: err }}>{succerr}</span>
                </div>
                {/* <ReCAPTCHA onChange={handleCaptcha} sitekey={process.env.REACT_APP_SITE_KEY} ref={captchaRef} /> */}
                <span onClick={handleResetPassword} className="forgot_password mb30">Forgot Password ?</span>
                <button type="button" onClick={handleLogin} className="button_login">Login</button>
              </form>
            </div>
            <div className='whitebox_wrp' style={{ display: loginforgot ? 'block' : 'none' }}>
              <form>
                <div className="login_head">
                  <div className="logo_blk float-start"><img src="assets/images/logo.png" /></div>
                </div>
                <div className="change_pass_wrp">
                  <h4>Set Password</h4>
                  <p className="mb25"> To reset your password, please enter your QBS Connect email. </p>
                </div>
                <div className="formblk mb20">
                  <label className="form-label">Email<span className="error_star">*</span><span style={{ color: err ? err : '' }}>{resetpassmsg}</span></label>
                  <div className="form-input">
                    <input type="email" value={emailresetpassword} onChange={(e) => { setEmailresetpassword(e.target.value) }} autoComplete='none' className="form-control" placeholder="Enter your Email" />
                  </div>
                </div>
                <p className="fs12">( <span>QBS Connect</span> will send the password reset instructions to the email address for this account. If you don't know your email address or is no longer valid, please Contact Us for further assistance. CONTACT US : qbsconnect@qbslearning.com )</p>
                <button type="button" className="button_login mb10" onClick={handleuserEmail}>Submit</button>
                <button type="button" className="button_border" onClick={handleResetPasswordCancel} >Cancel</button>
              </form>
            </div>

            <div className='whitebox_wrp' style={{ display: otpscreen ? 'block' : 'none' }}>
              <form>
                <div className="login_head">
                  <div className="logo_blk float-start"><img src="assets/images/logo.png" /></div>

                </div>
                <div className="change_pass_wrp">
                  <h4>Verification Code</h4>
                  <p className="mb25"> Enter your Verification Code We have sent you on your email address. </p>
                </div>
                <div className="formblk mb20">
                  <label className="form-label">OTP<span className="error_star">*</span><span style={{ color: err ? err : '' }}>{resetpassmsg}</span></label>
                  <div className="form-input">
                    <input type="email" value={otp} onChange={(e) => { setOtp(e.target.value) }} autoComplete='none' className="form-control" placeholder="Enter OTP" />
                  </div>
                </div>
                <button type="button" className="button_login mb10" onClick={handleuserOTP}>Verify</button>
                <p> If you didn't receive a code! <span style={{ color: '#0078b5', 'fontWeight': '500' }} className='hand' onClick={handleResendOtp}>Resend</span></p>
              </form>
            </div>

            <div className='whitebox_wrp' style={{ display: forgotpassword ? 'block' : 'none' }}>
              <form>
                <div className="login_head">
                  <div className="logo_blk float-start"><img src="assets/images/logo.png" /></div>

                </div>
                <div className="change_pass_wrp">
                  <h4>Create Your New Password</h4>
                  <p className="mb25">To Make your account secure, please create a new password to replace the temporary password.</p>
                </div>
                <div className="formblk mb20">
                  <label className="form-label">New Password <span className="error_star">*</span></label>
                  <div className="form-input">
                    <input type="password" value={newpassword} onChange={(e) => {
                      setNewpassword(e.target.value
                      )
                    }} className="form-control" placeholder="Enter your new password" />
                  </div>
                </div>
                <div className="formblk mb20">
                  <label className="form-label">Confirm New Password <span className="error_star">*</span><span style={{ color: err ? err : '' }}>{resetpassmsg}</span></label>
                  <div className="form-input">
                    <input type="password" value={confirmpassword} onChange={(e) => { setConfirmpassword(e.target.value) }} className="form-control" placeholder="Confirm your new password" />
                  </div>
                </div>

                <div className="formblk mb10">
                </div>
                <button type="button" className="button_login" onClick={handleChangePassword} >Save</button>
              </form>
            </div>
            {/* forgotpassword */}
          </div>
          <div className="copy"> @2023 Hive. All rights reserved.</div>
        </div>
      </div>
    </div>
  )
}

export default LoginComp
